import {
  ChevronLeft,
  ChevronRight,
  ExpandLess,
  ExpandMore,
  FmdGood,
  Mail,
  PersonAddAlt1,
  Phone,
  Search,
  Send,
  Videocam,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Collapse,
  Divider,
  IconButton,
  InputAdornment,
  List,
  Paper,
  Stack,
  TextField,
  Typography,
  Zoom,
} from "@mui/material";
import { blue, green, grey } from "@mui/material/colors";
import { useState } from "react";

function Chat() {
  const people = [
    {
      id: 1,
      first_name: "Ariana",
      last_name: "Grande",
      department: "Office",
      section: "Packaging",
      isLogged: true,
      town: "Nakuru",
      phone: "07254658454",
      mail: "ariana@exapmle.com",
    },
    {
      id: 2,
      first_name: "Solomon",
      last_name: "Wiseman",
      department: "OutSource",
      section: "Transport",
      isLogged: false,
      town: "Bungoma",
      phone: "07254658454",
      mail: "wered@exapmle.com",
    },
    {
      id: 3,
      first_name: "Solomon",
      last_name: "Wiseman",
      department: "OutSource",
      section: "Transport",
      isLogged: false,
      town: "Oloitokitok",
      phone: "07254658454",
      mail: "hghgh@exapmle.com",
    },
    {
      id: 4,
      first_name: "Solomon",
      last_name: "Wiseman",
      department: "OutSource",
      section: "Transport",
      isLogged: false,
      town: "Endebess",
      phone: "07254658454",
      mail: "dfdf@exapmle.com",
    },
    {
      id: 5,
      first_name: "Solomon",
      last_name: "Wiseman",
      department: "OutSource",
      section: "Transport",
      isLogged: false,
      town: "Kisumu",
      phone: "07254658454",
      mail: "ewre@exapmle.com",
    },
    {
      id: 6,
      first_name: "Solomon",
      last_name: "Wiseman",
      department: "OutSource",
      section: "Transport",
      isLogged: false,
      town: "Kitale",
      phone: "07254658454",
      mail: "qwew@exapmle.com",
    },
    {
      id: 7,
      first_name: "Solomon",
      last_name: "Wiseman",
      department: "OutSource",
      section: "Transport",
      isLogged: false,
      town: "Nairobi",
      phone: "07254658454",
      mail: "rert@exapmle.com",
    },
    {
      id: 8,
      first_name: "Solomon",
      last_name: "Wiseman",
      department: "OutSource",
      section: "Transport",
      isLogged: false,
      town: "Naivasha",
      phone: "07254658454",
      mail: "werr@exapmle.com",
    },
    {
      id: 9,
      first_name: "Solomon",
      last_name: "Wiseman",
      department: "OutSource",
      section: "Transport",
      isLogged: false,
      town: "Eldoret",
      phone: "07254658454",
      mail: "we@exapmle.com",
    },
  ];

  const [details, setDetails] = useState(null);
  //handling details
  const handleDetails = (person) => {
    setDetails(<Details person={person} />);
  };

  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack>
        <Typography variant="h6">Chat</Typography>
        <Divider variant="middle" />
        <Box display={"flex"} columnGap={2}>
          <Stack
            display={"flex"}
            justifyContent={"start"}
            width={"35%"}
            borderRight={"grey solid 1px"}
          >
            <Box display={"flex"} alignItems={"center"} mt={1}>
              <Avatar sx={{ height: 48, width: 48 }}>Profile</Avatar>
              <TextField
                size={"small"}
                sx={{ ml: 2, width: 200 }}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                  },
                }}
              />
              <IconButton sx={{ ml: "auto" }}>
                <ChevronLeft />
              </IconButton>
              <IconButton>
                <PersonAddAlt1 />
              </IconButton>
            </Box>
            <List style={{ maxHeight: 450, overflow: "auto" }} sx={{ mt: 1 }}>
              {people.map((person) => {
                return (
                  <Zoom
                    in={true}
                    style={{ transitionDelay: "200ms" }}
                    key={person.id}
                  >
                    <Card elevation={2} sx={{ width: "100%", my: 1 }}>
                      <CardActionArea onClick={() => handleDetails(person)}>
                        <CardContent>
                          <Box
                            display={"flex"}
                            alignItems={"center"}
                            columnGap={2}
                          >
                            <Avatar>{person.first_name[0]}</Avatar>
                            <Typography variant="body1">
                              {person.first_name} {person.last_name}
                            </Typography>
                          </Box>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Zoom>
                );
              })}
            </List>
          </Stack>
          <Stack my={1} width={"65%"}>
            {details}
          </Stack>
        </Box>
      </Stack>
    </Zoom>
  );
}

export default Chat;

function Details(props) {
  const { person } = props;

  const [showInfo, setshowInfo] = useState(false);
  const [showAttached, setshowAttached] = useState(false);

  const texts = [
    { text: "hi there and how are you", sent: true },
    { text: "hi too am doing great", sent: false },
    { text: "Just greeting you", sent: true },
    { text: "How is everyone there", sent: true },
    { text: "everyone is great, come visit us", sent: false },
    { text: "everyone is great, come visit us", sent: false },
    { text: "everyone is great, come visit us", sent: false },
    { text: "everyone is great, come visit us", sent: false },
    { text: "everyone is great, come visit us", sent: false },
    { text: "everyone is great, come visit us", sent: false },
  ];

  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack rowGap={1}>
        <Card>
          <CardActions>
            <Box display={"flex"} alignItems={"center"} width={"100%"}>
              <Avatar
                src="https://cdn.pixabay.com/photo/2017/05/22/07/20/woman-2333326_640.jpg"
                sx={{ height: 48, width: 48 }}
              >
                Pic
              </Avatar>
              <Typography ml={2}>
                {person.first_name} {person.last_name}
              </Typography>
              <IconButton sx={{ ml: "auto" }}>
                <Phone />
              </IconButton>
              <IconButton>
                <Videocam />
              </IconButton>
              <IconButton>
                <ChevronRight />
              </IconButton>
            </Box>
          </CardActions>
          <Divider />
          <CardContent>
            <Box display={"flex"}>
              <Stack
                padding={1}
                rowGap={2}
                display={"flex"}
                width={"70%"}
                style={{ maxHeight: 380, overflow: "auto" }}
              >
                {texts.map((text) => {
                  if (text.sent) {
                    return (
                      <Paper
                        sx={{
                          bgcolor: green[200],
                          borderRadius: 4,
                          padding: 1,
                          width: "45%",
                        }}
                        key={text}
                      >
                        <Typography variant="body2">{text.text}</Typography>
                      </Paper>
                    );
                  }
                  return (
                    <Paper
                      sx={{
                        ml: "auto",
                        bgcolor: blue[200],
                        borderRadius: 4,
                        padding: 1,
                        width: "45%",
                      }}
                      key={text}
                    >
                      <Typography variant="body2">{text.text}</Typography>
                    </Paper>
                  );
                })}
                <TextField
                  placeholder={"Text Here"}
                  fullWidth
                  sx={{ mt: 1, borderRadius: 4 }}
                  size="small"
                  maxRows={3}
                  slotProps={{
                    input: {
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton><Send /></IconButton>
                        </InputAdornment>
                      ),
                    },
                  }}
                  
                />
              </Stack>

              <Divider orientation="vertical" flexItem />
              <Stack width={"30%"} style={{ maxHeight: 450, overflow: "auto" }}>
                <Box display={"flex"} justifyContent={"center"} width={"100%"}>
                  <Avatar
                    sx={{ height: 96, width: 96 }}
                    src="https://cdn.pixabay.com/photo/2017/05/22/07/20/woman-2333326_640.jpg"
                  ></Avatar>
                </Box>
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"center"}
                  width={"100%"}
                >
                  <Typography variant="h6" mt={2}>
                    {person.first_name} {person.last_name}
                  </Typography>
                </Box>
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"center"}
                  width={"100%"}
                >
                  <Typography variant="body1">
                    {person.department} - {person.section}
                  </Typography>
                </Box>
                <CardActionArea
                  sx={{ mt: 1 }}
                  onClick={() => {
                    setshowInfo(!showInfo);
                  }}
                >
                  <Box
                    display={"flex"}
                    flexDirection={"row"}
                    width={"100%"}
                    padding={1}
                    bgcolor={grey[200]}
                    alignItems={"center"}
                  >
                    <Typography variant="subtitle" color="info">
                      INFO
                    </Typography>
                    <Typography ml={"auto"}>
                      {showInfo ? <ExpandLess /> : <ExpandMore />}
                    </Typography>
                  </Box>
                </CardActionArea>
                <Collapse in={showInfo} timeout="auto" unmountOnExit>
                  <Stack>
                    <Box
                      display={"flex"}
                      flexDirection={"row"}
                      padding={1}
                      columnGap={2}
                      alignItems={"center"}
                    >
                      <FmdGood /> <Typography> {person.town}</Typography>
                    </Box>
                    <Box
                      display={"flex"}
                      flexDirection={"row"}
                      padding={1}
                      columnGap={2}
                      alignItems={"center"}
                    >
                      <Phone />
                      <Typography> {person.phone}</Typography>
                    </Box>
                    <Box
                      display={"flex"}
                      flexDirection={"row"}
                      padding={1}
                      columnGap={2}
                      alignItems={"center"}
                    >
                      <Mail />
                      <Typography> {person.mail}</Typography>
                    </Box>
                  </Stack>
                </Collapse>
                <CardActionArea
                  sx={{ mt: 1 }}
                  onClick={() => {
                    setshowAttached(!showAttached);
                  }}
                >
                  <Box
                    display={"flex"}
                    flexDirection={"row"}
                    width={"100%"}
                    padding={1}
                    bgcolor={grey[200]}
                    alignItems={"center"}
                  >
                    <Typography variant="subtitle" color="info">
                      ATTACHMENTS
                    </Typography>
                    <Typography ml={"auto"}>
                      {showAttached ? <ExpandLess /> : <ExpandMore />}
                    </Typography>
                  </Box>
                </CardActionArea>
                <Collapse in={showAttached} timeout="auto" unmountOnExit>
                  <Stack>
                    <Typography>No Attachements</Typography>
                  </Stack>
                </Collapse>
              </Stack>
            </Box>
          </CardContent>
        </Card>
      </Stack>
    </Zoom>
  );
}
